import { render, staticRenderFns } from "./CadParametro.vue?vue&type=template&id=0c15fb30&"
import script from "./CadParametro.vue?vue&type=script&lang=js&"
export * from "./CadParametro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports